const userFields = {
  ADDRESS_CITY: 'City',
  ADDRESS_STATE: 'State',
  ADDRESS_STREET: 'Street Address',
  ADDRESS_ZIP: 'Zip Code',
  EMAIL: 'Email',
  PHONE: 'Phone',
  USER_ID: 'User ID',
  USER_NAME: 'User Name',
};

export {
  userFields,
};
